<template>
  <section>
    <div
      class="relative w-full overflow-hidden -mt-10"
      :style="
        'background: url(' +
        backgroundImage +
        '); background-size: cover; background-repeat: no-repeat; background-position: center center;'
      "
    >
      <div
        class="absolute inset-0 bg-gradient-to-t from-[#FBFCFE] via-transparent to-transparent z-10"
      ></div>

      <div
        class="relative z-20 flex flex-col xl:flex-row items-center xl:items-start justify-between max-w-screen-xl mx-auto px-4 sm:px-6 xl:px-10 gap-10 xl:gap-5 sm:mt-12 xl:mt-20"
      >
        <div
          class="w-full xl:w-1/2 flex flex-col items-center xl:items-start text-center xl:text-left mt-16"
          data-aos="fade-right"
        >
          <div class="title-content max-w-lg text-2xl font-semibold text-gray-900 md:text-3xl">
            <slot name="title">
              <div v-html="title"></div>
            </slot>
          </div>
          <div class="subtitle-content mt-6 max-w-lg text-base text-gray-700 md:text-lg">
            <slot name="subtitle">
              <div v-html="subtitle"></div>
            </slot>
          </div>
        </div>

        <div
          class="w-full xl:w-1/2 flex justify-center h-full"
          data-aos="fade-left"
        >
          <div class="max-w-xl w-full">
            <DownloadForm 
              :data-form-id="dataFormId"
              :data-portal-id="dataPortalId"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DownloadForm from "./DownloadForm.vue";
export default {
  props: {
    title: String,
    subtitle: String,
    backgroundImage: String,
    altImage: String,
    dataFormId: String,
    dataPortalId: String,
  },

  components: {
    DownloadForm,
  },
};
</script>

<style scoped>
.title-content :deep(ul),
.title-content :deep(ol),
.subtitle-content :deep(ul),
.subtitle-content :deep(ol) {
  padding-left: 1.25rem;
}
</style>
